// French — mirrors src/i18n/local/en/common.ts for French-speaking buyers (FR/BE/CH/CA).

const common = {
  // Navigation
  "nav.home": "Accueil",
  "nav.products": "Produits",
  "nav.factory": "Usine",
  "nav.about": "À propos",
  "nav.contact": "Contact",
  "nav.requestQuote": "Demander un devis",
  "nav.menu": "Menu",
  "nav.language": "Langue",

  "cta.requestQuote": "Demander un devis",
  "cta.exploreCatalog": "Voir le catalogue",
  "cta.contactUs": "Nous contacter",
  "cta.scheduleFactoryVisit": "Planifier une visite d'usine",
  "cta.requestSample": "Demander un échantillon",
  "cta.viewAll": "Tous les produits",

  "common.tbd": "[À confirmer par Forwaro]",
  "common.category": "Catégorie",
  "common.material": "Matière",
  "common.style": "Style",
  "common.filters": "Filtres",
  "common.resetAll": "Réinitialiser",
  "common.details": "Détails",

  "brand.name": "Forwaro Furniture",
  "brand.chineseName": "風華國際",
  "brand.tagline": "FORWARO FURNITURE · 風華國際 · 現代傢俱",
  "whatsapp.cta": "Écrivez-nous sur WhatsApp",
  "wechat.cta": "Ajoutez-nous sur WeChat",

  "home.hero.badge": "FORWARO · 風華國際 · 現代傢俱",
  "home.hero.headline.line1": "La maison est",
  "home.hero.headline.line2Highlight": "le centre de tout",
  "home.hero.headline.line3": "dans une vie bien remplie.",
  "home.hero.subheadline": "Forwaro Furniture (風華國際) est un fabricant OEM / ODM basé à Dongguan, alliant design de mobilier et qualité de production constante pour les importateurs du Moyen-Orient, d'Europe, des Amériques et d'Asie.",
  "home.hero.stat1.value": "6",
  "home.hero.stat1.label": "Gammes de produits",
  "home.hero.stat2.value": "OEM / ODM",
  "home.hero.stat2.label": "Production sur mesure",
  "home.hero.stat3.value": "Dongguan",
  "home.hero.stat3.label": "Zone industrielle de Min Tian",
  "home.hero.stat4.value": "Mondial",
  "home.hero.stat4.label": "Partenariats à l'export",
  "home.hero.scroll": "Défiler",

  "home.categories.kicker": "Notre gamme",
  "home.categories.heading": "Six gammes de produits, une usine de confiance",
  "home.categories.description": "Tables à manger, tables basses, consoles, chaises, canapés et meubles TV : les six gammes de mobilier B2B que Forwaro produit pour l'export.",

  "home.about.kicker": "À propos de Forwaro",
  "home.about.heading.line1": "Design du meuble,",
  "home.about.heading.line2": "constance du savoir-faire.",
  "home.about.philosophy.en":
    "La maison est le centre d'une vie trépidante, où l'esthétique de l'habitat devient le goût et la quête des personnes accomplies. Forwaro Furniture défend la cohérence du design et de la qualité — pour que votre intérieur marie esthétique et artisanat.",
  "home.about.location": "Forwaro Furniture (風華國際有限公司) a été fondée à Taiwan en 1991 et fabrique en Chine continentale depuis 2006. L'entreprise opère aujourd'hui depuis la Min Tian Industrial Zone, à Shatian Town, Dongguan. Forwaro s'associe à des importateurs qui privilégient un savoir-faire honnête et des livraisons fiables.",
  "home.about.highlight1.title": "OEM et ODM",
  "home.about.highlight1.body":
    "Production sur mesure — du private label aux projets totalement personnalisés.",
  "home.about.highlight2.title": "Contrôle qualité à l'export",
  "home.about.highlight2.body":
    "Inspection à chaque étape : menuiserie, tapisserie, finitions, emballage.",
  "home.about.highlight3.title": "Marbre naturel & acier",
  "home.about.highlight3.body": "Des plateaux signature en marbre naturel, associés à des piétements en acier inoxydable galvanisé et en fer.",
  "home.about.highlight4.title": "Portée mondiale",
  "home.about.highlight4.body": "Depuis Dongguan, nous servons les importateurs du Moyen-Orient, d'Europe, des Amériques et d'Asie.",
  "home.about.badgeLocation": "Dongguan, Chine",
  "home.about.badgeZone": "Zone industrielle Min Tian",
  "home.about.badgeOem": "OEM /\nODM",
  "home.about.badgeOemSub": "Sur mesure & private label",

  "home.featured.kicker": "Aperçu du catalogue",
  "home.featured.heading": "Un aperçu des six gammes de Forwaro",
  "home.featured.description": "De véritables références Forwaro, aux matériaux et dimensions confirmés. Contactez-nous pour obtenir les spécifications complètes et un devis.",


  "home.markets.kicker": "Portée mondiale",
  "home.markets.heading": "Nos marchés à l'export",
  "home.markets.description":
    "Forwaro collabore avec importateurs, distributeurs, groupes hôteliers et projets résidentiels sur quatre continents.",

  "home.process.heading": "Comment nous travaillons",
  "home.process.description":
    "De la première demande au chargement du conteneur — le flux export standard de Forwaro.",

  "footer.getInTouch.kicker": "Contact",
  "footer.getInTouch.heading":
    "Démarrez votre import de meubles\navec Forwaro",
  "footer.getInTouch.description":
    "Notre équipe export prépare devis personnalisés, échantillons et documents complets pour votre marché.",
  "footer.contact.email": "E-mail",
  "footer.contact.phone": "Téléphone",
  "footer.contact.fax": "Fax",
  "footer.contact.factory": "Usine",
  "footer.contact.whatsappNote":
    "Canaux WhatsApp et WeChat — à confirmer par Forwaro.",
  "footer.form.heading": "Demander un devis",
  "footer.form.name": "Nom complet",
  "footer.form.email": "E-mail",
  "footer.form.company": "Entreprise",
  "footer.form.country": "Pays",
  "footer.form.countryPlaceholder": "Sélectionner un pays",
  "footer.form.message": "Message",
  "footer.form.messagePlaceholder":
    "Décrivez vos exigences, quantités et marché cible…",
  "footer.form.submit": "Envoyer la demande",
  "footer.form.sending": "Envoi…",
  "footer.form.success.heading": "Envoyé !",
  "footer.form.success.body":
    "Notre équipe export répondra sous deux jours ouvrés.",
  "footer.form.sendAnother": "Envoyer un autre message",
  "footer.footerTagline": "Forwaro Furniture · 風華國際 · 現代傢俱. Fabricant OEM/ODM basé à Dongguan, au service des importateurs du Moyen-Orient, d'Europe, des Amériques et d'Asie.",
  "footer.col.products": "Produits",
  "footer.col.company": "Entreprise",
  "footer.col.markets": "Marchés export",
  "footer.col.regional": "Vous recherchez un représentant régional ?",
  "footer.copyright": "Tous droits réservés.",
};

export default common;
